import React, { useState, useEffect } from 'react';
import { getFirestore, collection, getDocs, doc, updateDoc, getDoc, onSnapshot } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import appFirebase from '../Firebase/Firebase';
import Footer from '../Components/footer';
import Navbar from '../Components/NavBarAirbnbStyle';
import ProgressCircle2 from '../Pages/ProgressCircleDiseño2';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './coinpurchase.css';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion';
import Membresias from './Membresias';
import { FaWallet, FaClock } from 'react-icons/fa';
const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);

const CoinPurchase = () => {
  const [coinPackages, setCoinPackages] = useState([]);
  const [user, setUser] = useState(null);
  const [role, setRole] = useState('');
  const [tiempoRestante, setTiempoRestante] = useState('');
  const [progress, setProgress] = useState(0);
  const [time, setTime] = useState(0);
  const [purchaseDate, setPurchaseDate] = useState(new Date());
  const [expirationDate, setExpirationDate] = useState(new Date());
  const [isOn, setIsOn] = useState(false);
  const [coins, setCoins] = useState(0);
  const [coinsComprados, setCoinsComprados] = useState(0);
  const [diasRes, setDiasRes] = useState(0);
  // Estado para el switch

  const navigate = useNavigate(); // Inicializar el hook


  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userDocRef = doc(db, 'usuarios', currentUser.uid);

        // Listener en tiempo real para los datos del usuario
        const unsubscribeSnapshot = onSnapshot(userDocRef, (doc) => {
          if (doc.exists()) {
            const userData = doc.data();
            setCoins(userData.coins || 0);
            setCoinsComprados(userData.coinsComprados || 0);
            if (userData.coinRenovation && userData.coinExpiration) {
              let parsedPurchaseDate, parsedExpirationDate;
              if (typeof userData.coinRenovation === 'object' && userData.coinRenovation.seconds) {
                parsedPurchaseDate = new Date(userData.coinRenovation.seconds * 1000);
                parsedExpirationDate = new Date(userData.coinExpiration.seconds * 1000);
              }
              if (!isNaN(parsedPurchaseDate) && !isNaN(parsedExpirationDate)) {
                setPurchaseDate(parsedPurchaseDate);
                setExpirationDate(parsedExpirationDate);
              } else {
                console.error('Las fechas no son válidas después de la conversión.');
              }
            }
          }
        });
        return () => unsubscribeSnapshot();
      }
    });
    return () => unsubscribeAuth();
  }, []);

  useEffect(() => {
    if (coinsComprados > 0) {
      const calculatedProgress = (coins / coinsComprados) * (100);
      setProgress(calculatedProgress);
      const now = new Date();
      const totalDuration = expirationDate - purchaseDate;
      setDiasRes(Math.floor(totalDuration / (1000 * 3600 * 24)));
      const differenceInTime = expirationDate - now;  // Diferencia en milisegundos
      const calculatedTime = (differenceInTime / totalDuration) * (100);
      setTime(calculatedTime);
      // Calculamos los días, horas y minutos restantes
      const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));
      const differenceInHours = Math.floor((differenceInTime % (1000 * 3600 * 24)) / (1000 * 3600));
      const differenceInMinutes = Math.floor((differenceInTime % (1000 * 3600)) / (1000 * 60));
      setTiempoRestante(`${differenceInDays}d, ${differenceInHours} h, ${differenceInMinutes} m`);
    } else {

      setProgress(100); // Si coinsComprados es 0, el progreso es mínimo
    }
  }, [coins, coinsComprados, purchaseDate, expirationDate]);


  useEffect(() => {
    fetchCoinPackages();
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userDocRef = doc(db, 'usuarios', currentUser.uid);
        const docSnap = await getDoc(userDocRef);
        if (docSnap.exists()) {
          setRole(docSnap.data().role);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  const fetchCoinPackages = async () => {
    const querySnapshot = await getDocs(collection(db, 'coinPackages'));
    const packages = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));
    setCoinPackages(packages);

  };

  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      // Intentamos leer valor guardado en localStorage
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
      }
    } catch (error) {
      // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    // Detectar modo oscuro sistema solo si está disponible window.matchMedia
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    // Detectar hora nocturna (7pm a 6am)
    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;

    // Retorna true o false seguro
    return prefersDark || isNight;
  });

  // Cargar el tema al inicio (localStorage, sistema u hora)
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      // Detecta modo oscuro sistema
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

      // Detecta modo oscuro por hora (7pm - 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;

      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  // Guardar la preferencia y aplicar clase al body
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  // Función para cambiar el modo
  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

  return (
    <div>
      <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <ToastContainer />
      
      <div>

      </div>
      
      <div className="wallet-card-container">
        <h3 className="wallet-title"><FaWallet /> My Wallet</h3>
        <p className="wallet-exchange-rate">
          Exchange Rate: <strong>40 Coins = US$1</strong>
        </p>
        <div className="wallet-progress-container">
          <ProgressCircle2
            progress={progress}
            secondaryProgress={time}
            coins={coins}
            coinsComprados={coinsComprados}
            diasRestantes={diasRes}
          />
          <div className="wallet-text-status">
            {time > 0 ? (
              <h4>Te quedan <br /><strong>{tiempoRestante}</strong> de vigencia de tus coins</h4>
            ) : (
              <h4>💡 Recarga tus Coins</h4>
            )}
          </div>
        </div>

        <div className="wallet-card-content">
          <div>
            <p className="wallet-label">CURRENT BALANCE</p>
            <h1 className="wallet-balance"><FaClock /> {coins} Coins</h1>
          </div>
        </div>
      </div>

      <Membresias />


    </div>
  );
};

export default CoinPurchase;
